var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-container",class:{ on: _vm.isLoading }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-bg"},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif"),"alt":"spinner"}})])
}]

export { render, staticRenderFns }